import React, { useState } from 'react';
import { App } from 'antd';
import DebounceSelect from 'components/Select/DebounceSelect';
import { captureException } from 'utils/errors';
import http from 'utils/http';

function UserSelectInput({
  value,
  onChange,
  placeholder = 'Change owner...',
  disabled = false,
  style = {},
  renderLabel = (user) => user.email,
  ...props
}) {
  const [loading, setLoading] = useState(false);
  const { message } = App.useApp();

  const fetchUserOptions = async (search) => {
    setLoading(true);
    try {
      const res = await http.get('v1/user/organization/{{organizationId}}/users-permissions/', { params: { search } });
      return (res.data?.data?.results || []).map((user) => ({
        value: user.id,
        label: renderLabel(user),
      }));
    } catch (e) {
      captureException(e);
      message.error('Failed to fetch users');
      return [];
    } finally {
      setLoading(false);
    }
  };

  return (
    <DebounceSelect
      style={{ width: '100%', ...style }}
      value={value}
      fetchOptions={fetchUserOptions}
      onChange={onChange}
      placeholder={placeholder}
      allowClear
      disabled={disabled}
      loading={loading}
      {...props}
    />
  );
}

export default UserSelectInput;
